import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const usdFutureHistorySchema = z.object({
  /** 取引シンボル（存在する場合） */
  symbol: z.string().optional(),
  /** 収益タイプ */
  incomeType: z.string(),
  /** 収益金額（符号付き文字列） */
  income: decimalSchema,
  /** 収益対象のアセット名 */
  asset: z.string(),
  /** 補足情報 */
  info: z.string(),
  /** タイムスタンプ（ミリ秒） */
  time: z.number(),
  /** トランザクションID */
  tranId: z.number(),
  /** トレードID（存在する場合） */
  tradeId: z.string().optional(),
})

export const responseSchema = z.array(usdFutureHistorySchema)
